"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcessibilidadeAddDimBtn = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var React = __importStar(require("react"));
var h5_component_1 = require("../../../token/heading/h5/h5.component");
var styles_1 = require("./styles");
var AcessibilidadeAddDimBtn = function (_a) {
    var onClickInc = _a.onClickInc, onClickDec = _a.onClickDec;
    var theme = (0, temas_frontend_1.useTheme)().theme;
    return (React.createElement(styles_1.AddDimBtnSectionStyled, null,
        React.createElement(styles_1.AddDimBtnButtonStyled, { onClick: onClickDec },
            React.createElement(h5_component_1.H5, { color: theme.p003 }, "A-")),
        React.createElement(styles_1.AddDimBtnButtonStyled, { onClick: onClickInc },
            React.createElement(h5_component_1.H5, { color: theme.p003 }, "A+"))));
};
exports.AcessibilidadeAddDimBtn = AcessibilidadeAddDimBtn;
